(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["k3-ui"] = factory();
	else
		root["k3-ui"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 